function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "overview_svg__a",
  opacity: 1,
  fillRule: "evenodd",
  d: "M.5 9l8.508-8L17.5 9"
}), React.createElement("path", {
  id: "overview_svg__b",
  opacity: 1,
  fillRule: "evenodd",
  d: "M3.5 9.007V17H7v-5h4v5h3.5V9.007"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#overview_svg__a",
  fillOpacity: 0,
  stroke: "#8395B7",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#overview_svg__b",
  fillOpacity: 0,
  stroke: "#8395B7",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgOverview = function SvgOverview(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: 18.015,
    width: 18.015,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOverview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/overview.fdb9447e.svg";
export { ForwardRef as ReactComponent };